// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"1692348f","369":"a7da3365","701":"9342e55e","728":"7cf92ce1","769":"8074b54a"}[chunkId] + ".chunk.js";
};